// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Thicker-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Thicker-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/obstcles.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: lightThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: medThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.contact_wrapper {
  width: 100%;
  position: relative;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.contact_main_div {
  width: 100%;
  background-color: #fff !important;
}

.band_img_div_contact {
  width: 100%;
}

.band_img_div_contact > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* contact form styling start here---------------------------- */

.contact_form_main_div {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact_form_div {
  width: 100%;
  padding: 0 80px;
}

.contact_form {
  width: 100%;
  display: flex;
  margin-top: 30px;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20 !important;
}

.contact_field_box {
  width: calc(33% - 20px);
  display: flex;
  flex-direction: column;
  margin: 0 10px 25px 10px;
}

.contact_field_box > label {
  color: #000;
  font-family: lightThicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 4px;
}

.contact_field {
  height: 50px !important;
  flex-shrink: 0;
  padding: 0 17px;

  border-radius: 4px;
  border: 1px solid #d2d3d4;
  color: #000103;
  font-family: lightThicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.25px;
  outline: none;
}

.contact_text_area {
  width: 66%;
  display: flex;
  flex-direction: column;
  margin: 0 0 25px 0;
}

.contact_text_area > label {
  color: #000;
  font-family: lightThicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 4px;
}

.contact_text_area_field {
  height: 152px !important;
  flex-shrink: 0;
  padding: 0 17px;

  border-radius: 4px;
  border: 1px solid #d2d3d4;
  color: #000103;
  font-family: lightThicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.25px;
  outline: none;
  resize: none;
}

.contact_invalid_feedback {
  color: #e42323;
  font-family: lightThicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.25px;
  margin-top: 4px;
}

.contact_join_btn_div {
  display: flex;
  width: 180px;
  height: 54px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  background: linear-gradient(0deg, #ba1e24 0%, #ba1e24 100%), #fff;
  color: #fff;
  font-family: lightThicker;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 126.6%;
  border: none;
  margin-bottom: 50px;
}

/* obstacles styling start here -------------------------------------------- */

.contact_obstacles_div {
  width: 100%;
  height: 87px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media screen and (max-width: 1200px) {
  /* contact form styling start here---------------------------- */

  .contact_form_div {
    width: 100%;
    padding: 0 50px;
  }

  .contact_form {
    /* justify-content: space-between; */
    gap: 20 !important;
  }

  .contact_field_box {
    width: calc(33% - 20px);
    margin: 0 10px 20px 10px;
  }

  .contact_field_box > label {
    font-size: 18px;
    margin-bottom: 4px;
  }

  .contact_field {
    height: 50px !important;
    padding: 0 17px;
    font-size: 14px;
    line-height: 18px;
  }

  .contact_text_area {
    width: 66%;
    margin: 0 0 20px 0;
  }

  .contact_text_area > label {
    font-size: 18px;
    margin-bottom: 4px;
  }

  .contact_text_area_field {
    height: 130px !important;
    padding: 0 17px;
    font-size: 14px;
    line-height: 18px;
  }

  .contact_invalid_feedback {
    font-size: 14px;
    line-height: 18px;
    margin-top: 4px;
  }

  .contact_join_btn_div {
    width: 150px;
    height: 45px;
    gap: 10px;
    font-size: 20px;
    margin-bottom: 60px;
  }

  /* obstacles styling start here -------------------------------------------- */

  .contact_obstacles_div {
    height: 87px;
  }
}

@media screen and (max-width: 1024px) {
  /* contact form styling start here---------------------------- */

  .contact_form_div {
    width: 100%;
    padding: 0 40px;
  }

  .contact_form {
    /* justify-content: space-between; */
    gap: 20 !important;
  }

  .contact_field_box {
    width: calc(50% - 10px);
    margin: 0 5px 20px 5px;
  }

  .contact_field_box > label {
    font-size: 18px;
    margin-bottom: 4px;
  }

  .contact_field {
    height: 50px !important;
    padding: 0 17px;
    font-size: 14px;
    line-height: 18px;
  }

  .contact_text_area {
    width: 100%;
    margin: 0 0 20px 0;
  }

  .contact_text_area > label {
    font-size: 18px;
    margin-bottom: 4px;
  }

  .contact_text_area_field {
    height: 130px !important;
    padding: 12px 17px;
    font-size: 14px;
    line-height: 18px;
  }

  .contact_invalid_feedback {
    font-size: 14px;
    line-height: 18px;
    margin-top: 4px;
  }

  .contact_join_btn_div {
    width: 150px;
    height: 45px;
    gap: 10px;
    font-size: 20px;
    margin-bottom: 60px;
  }

  /* obstacles styling start here -------------------------------------------- */

  .contact_obstacles_div {
    height: 87px;
  }
}

@media screen and (max-width: 800px) {
  /* contact form styling start here---------------------------- */

  .contact_form_div {
    width: 100%;
    padding: 0 30px;
  }

  .contact_form {
    /* justify-content: space-between; */
    gap: 20 !important;
  }

  .contact_field_box {
    width: calc(50% - 6px);
    margin: 0 3px 16px 3px;
  }

  .contact_field_box > label {
    font-size: 16px;
    margin-bottom: 2px;
  }

  .contact_field {
    height: 45px !important;
    padding: 0 14px;
    font-size: 14px;
    line-height: 18px;
  }

  .contact_text_area {
    width: 100%;
    margin: 0 0 16px 0;
  }

  .contact_text_area > label {
    font-size: 16px;
    margin-bottom: 2px;
  }

  .contact_text_area_field {
    height: 120px !important;
    padding: 10px 14px;
    font-size: 14px;
    line-height: 18px;
  }

  .contact_invalid_feedback {
    font-size: 14px;
    line-height: 18px;
    margin-top: 4px;
  }

  .contact_join_btn_div {
    width: 140px;
    height: 42px;
    gap: 10px;
    font-size: 18px;
    margin-bottom: 60px;
  }

  /* obstacles styling start here -------------------------------------------- */

  .contact_obstacles_div {
    height: 70px;
    background-repeat: repeat;
    background-position: center;
  }
}

@media screen and (max-width: 600px) {
  /* contact form styling start here---------------------------- */

  .contact_form_div {
    width: 100%;
    padding: 0 20px;
  }

  .band_img_div_contact {
    width: 100%;
    padding: 0 !important;
    overflow: hidden;
   }
   
   .band_img_div_contact > img {
     width: 280% !important; 
     height: 50px !important;
     margin-left: -50px;
   }
  .contact_form {
    /* justify-content: space-between; */
    gap: 10 !important;
  }

  .contact_field_box {
    width: 100%;
    margin: 0 0 16px 0;
  }

  .contact_field_box > label {
    font-size: 16px;
    margin-bottom: 2px;
  }

  .contact_field {
    height: 45px !important;
    padding: 0 10px;
    font-size: 14px;
    line-height: 18px;
  }

  .contact_text_area {
    width: 100%;
    margin: 0 0 12px 0;
  }

  .contact_text_area > label {
    font-size: 16px;
    margin-bottom: 2px;
  }

  .contact_text_area_field {
    height: 120px !important;
    padding: 10px 10px;
    font-size: 14px;
    line-height: 18px;
  }

  .contact_invalid_feedback {
    font-size: 14px;
    line-height: 18px;
    margin-top: 4px;
  }

  .contact_join_btn_div {
    width: 140px;
    height: 42px;
    gap: 10px;
    font-size: 18px;
    margin-bottom: 60px;
  }

  /* obstacles styling start here -------------------------------------------- */

  .contact_obstacles_div {
    height: 60px;
    background-repeat: repeat;
    background-position: center;
  }
}

@media screen and (max-width: 450px) {
  /* contact form styling start here---------------------------- */

  .contact_form_div {
    width: 100%;
    padding: 0 16px;
  }

  .contact_form {
    justify-content: center;
    gap: 0 !important;
  }

  .contact_field_box {
    width: 100%;
    margin: 0 0 16px 0;
  }

  .contact_field_box > label {
    font-size: 16px;
    margin-bottom: 2px;
  }

  .contact_field {
    height: 42px !important;
    padding: 0 10px;
    font-size: 14px;
    line-height: 18px;
  }

  .contact_text_area {
    width: 100%;
    margin: 0 0 12px 0;
  }

  .contact_text_area > label {
    font-size: 16px;
    margin-bottom: 2px;
  }

  .contact_text_area_field {
    height: 100px !important;
    padding: 10px 10px;
    font-size: 14px;
    line-height: 18px;
  }

  .contact_invalid_feedback {
    font-size: 14px;
    line-height: 18px;
    margin-top: 4px;
  }

  .contact_join_btn_div {
    width: 120px;
    height: 40px;
    gap: 10px;
    font-size: 18px;
    margin-bottom: 40px;
  }

  /* obstacles styling start here -------------------------------------------- */

  .contact_obstacles_div {
    height: 60px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/contactUs/contactUs.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4CAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,4CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gEAAgE;;AAEhE;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;;EAEf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,eAAe;;EAEf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iEAAiE;EACjE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8EAA8E;;AAE9E;EACE,WAAW;EACX,YAAY;EACZ,yDAAkD;AACpD;;AAEA;EACE,gEAAgE;;EAEhE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA,8EAA8E;;EAE9E;IACE,YAAY;EACd;AACF;;AAEA;EACE,gEAAgE;;EAEhE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA,8EAA8E;;EAE9E;IACE,YAAY;EACd;AACF;;AAEA;EACE,gEAAgE;;EAEhE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA,8EAA8E;;EAE9E;IACE,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;;AAEA;EACE,gEAAgE;;EAEhE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,gBAAgB;GACjB;;GAEA;KACE,sBAAsB;KACtB,uBAAuB;KACvB,kBAAkB;GACpB;EACD;IACE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA,8EAA8E;;EAE9E;IACE,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;;AAEA;EACE,gEAAgE;;EAEhE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA,8EAA8E;;EAE9E;IACE,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;EACxB;AACF","sourcesContent":["@font-face {\n  font-family: lightThicker;\n  src: url(../../assets/fonts/Thicker-Regular.otf);\n}\n\n@font-face {\n  font-family: medThicker;\n  src: url(../../assets/fonts/Thicker-Bold.otf);\n}\n\n.contact_wrapper {\n  width: 100%;\n  position: relative;\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.contact_main_div {\n  width: 100%;\n  background-color: #fff !important;\n}\n\n.band_img_div_contact {\n  width: 100%;\n}\n\n.band_img_div_contact > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* contact form styling start here---------------------------- */\n\n.contact_form_main_div {\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.contact_form_div {\n  width: 100%;\n  padding: 0 80px;\n}\n\n.contact_form {\n  width: 100%;\n  display: flex;\n  margin-top: 30px;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: 20 !important;\n}\n\n.contact_field_box {\n  width: calc(33% - 20px);\n  display: flex;\n  flex-direction: column;\n  margin: 0 10px 25px 10px;\n}\n\n.contact_field_box > label {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin-bottom: 4px;\n}\n\n.contact_field {\n  height: 50px !important;\n  flex-shrink: 0;\n  padding: 0 17px;\n\n  border-radius: 4px;\n  border: 1px solid #d2d3d4;\n  color: #000103;\n  font-family: lightThicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0.25px;\n  outline: none;\n}\n\n.contact_text_area {\n  width: 66%;\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 25px 0;\n}\n\n.contact_text_area > label {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin-bottom: 4px;\n}\n\n.contact_text_area_field {\n  height: 152px !important;\n  flex-shrink: 0;\n  padding: 0 17px;\n\n  border-radius: 4px;\n  border: 1px solid #d2d3d4;\n  color: #000103;\n  font-family: lightThicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0.25px;\n  outline: none;\n  resize: none;\n}\n\n.contact_invalid_feedback {\n  color: #e42323;\n  font-family: lightThicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: 0.25px;\n  margin-top: 4px;\n}\n\n.contact_join_btn_div {\n  display: flex;\n  width: 180px;\n  height: 54px;\n  padding: 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  background: linear-gradient(0deg, #ba1e24 0%, #ba1e24 100%), #fff;\n  color: #fff;\n  font-family: lightThicker;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 126.6%;\n  border: none;\n  margin-bottom: 50px;\n}\n\n/* obstacles styling start here -------------------------------------------- */\n\n.contact_obstacles_div {\n  width: 100%;\n  height: 87px;\n  background-image: url(\"../../assets/obstcles.png\");\n}\n\n@media screen and (max-width: 1200px) {\n  /* contact form styling start here---------------------------- */\n\n  .contact_form_div {\n    width: 100%;\n    padding: 0 50px;\n  }\n\n  .contact_form {\n    /* justify-content: space-between; */\n    gap: 20 !important;\n  }\n\n  .contact_field_box {\n    width: calc(33% - 20px);\n    margin: 0 10px 20px 10px;\n  }\n\n  .contact_field_box > label {\n    font-size: 18px;\n    margin-bottom: 4px;\n  }\n\n  .contact_field {\n    height: 50px !important;\n    padding: 0 17px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .contact_text_area {\n    width: 66%;\n    margin: 0 0 20px 0;\n  }\n\n  .contact_text_area > label {\n    font-size: 18px;\n    margin-bottom: 4px;\n  }\n\n  .contact_text_area_field {\n    height: 130px !important;\n    padding: 0 17px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .contact_invalid_feedback {\n    font-size: 14px;\n    line-height: 18px;\n    margin-top: 4px;\n  }\n\n  .contact_join_btn_div {\n    width: 150px;\n    height: 45px;\n    gap: 10px;\n    font-size: 20px;\n    margin-bottom: 60px;\n  }\n\n  /* obstacles styling start here -------------------------------------------- */\n\n  .contact_obstacles_div {\n    height: 87px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  /* contact form styling start here---------------------------- */\n\n  .contact_form_div {\n    width: 100%;\n    padding: 0 40px;\n  }\n\n  .contact_form {\n    /* justify-content: space-between; */\n    gap: 20 !important;\n  }\n\n  .contact_field_box {\n    width: calc(50% - 10px);\n    margin: 0 5px 20px 5px;\n  }\n\n  .contact_field_box > label {\n    font-size: 18px;\n    margin-bottom: 4px;\n  }\n\n  .contact_field {\n    height: 50px !important;\n    padding: 0 17px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .contact_text_area {\n    width: 100%;\n    margin: 0 0 20px 0;\n  }\n\n  .contact_text_area > label {\n    font-size: 18px;\n    margin-bottom: 4px;\n  }\n\n  .contact_text_area_field {\n    height: 130px !important;\n    padding: 12px 17px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .contact_invalid_feedback {\n    font-size: 14px;\n    line-height: 18px;\n    margin-top: 4px;\n  }\n\n  .contact_join_btn_div {\n    width: 150px;\n    height: 45px;\n    gap: 10px;\n    font-size: 20px;\n    margin-bottom: 60px;\n  }\n\n  /* obstacles styling start here -------------------------------------------- */\n\n  .contact_obstacles_div {\n    height: 87px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  /* contact form styling start here---------------------------- */\n\n  .contact_form_div {\n    width: 100%;\n    padding: 0 30px;\n  }\n\n  .contact_form {\n    /* justify-content: space-between; */\n    gap: 20 !important;\n  }\n\n  .contact_field_box {\n    width: calc(50% - 6px);\n    margin: 0 3px 16px 3px;\n  }\n\n  .contact_field_box > label {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n\n  .contact_field {\n    height: 45px !important;\n    padding: 0 14px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .contact_text_area {\n    width: 100%;\n    margin: 0 0 16px 0;\n  }\n\n  .contact_text_area > label {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n\n  .contact_text_area_field {\n    height: 120px !important;\n    padding: 10px 14px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .contact_invalid_feedback {\n    font-size: 14px;\n    line-height: 18px;\n    margin-top: 4px;\n  }\n\n  .contact_join_btn_div {\n    width: 140px;\n    height: 42px;\n    gap: 10px;\n    font-size: 18px;\n    margin-bottom: 60px;\n  }\n\n  /* obstacles styling start here -------------------------------------------- */\n\n  .contact_obstacles_div {\n    height: 70px;\n    background-repeat: repeat;\n    background-position: center;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  /* contact form styling start here---------------------------- */\n\n  .contact_form_div {\n    width: 100%;\n    padding: 0 20px;\n  }\n\n  .band_img_div_contact {\n    width: 100%;\n    padding: 0 !important;\n    overflow: hidden;\n   }\n   \n   .band_img_div_contact > img {\n     width: 280% !important; \n     height: 50px !important;\n     margin-left: -50px;\n   }\n  .contact_form {\n    /* justify-content: space-between; */\n    gap: 10 !important;\n  }\n\n  .contact_field_box {\n    width: 100%;\n    margin: 0 0 16px 0;\n  }\n\n  .contact_field_box > label {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n\n  .contact_field {\n    height: 45px !important;\n    padding: 0 10px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .contact_text_area {\n    width: 100%;\n    margin: 0 0 12px 0;\n  }\n\n  .contact_text_area > label {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n\n  .contact_text_area_field {\n    height: 120px !important;\n    padding: 10px 10px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .contact_invalid_feedback {\n    font-size: 14px;\n    line-height: 18px;\n    margin-top: 4px;\n  }\n\n  .contact_join_btn_div {\n    width: 140px;\n    height: 42px;\n    gap: 10px;\n    font-size: 18px;\n    margin-bottom: 60px;\n  }\n\n  /* obstacles styling start here -------------------------------------------- */\n\n  .contact_obstacles_div {\n    height: 60px;\n    background-repeat: repeat;\n    background-position: center;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  /* contact form styling start here---------------------------- */\n\n  .contact_form_div {\n    width: 100%;\n    padding: 0 16px;\n  }\n\n  .contact_form {\n    justify-content: center;\n    gap: 0 !important;\n  }\n\n  .contact_field_box {\n    width: 100%;\n    margin: 0 0 16px 0;\n  }\n\n  .contact_field_box > label {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n\n  .contact_field {\n    height: 42px !important;\n    padding: 0 10px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .contact_text_area {\n    width: 100%;\n    margin: 0 0 12px 0;\n  }\n\n  .contact_text_area > label {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n\n  .contact_text_area_field {\n    height: 100px !important;\n    padding: 10px 10px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .contact_invalid_feedback {\n    font-size: 14px;\n    line-height: 18px;\n    margin-top: 4px;\n  }\n\n  .contact_join_btn_div {\n    width: 120px;\n    height: 40px;\n    gap: 10px;\n    font-size: 18px;\n    margin-bottom: 40px;\n  }\n\n  /* obstacles styling start here -------------------------------------------- */\n\n  .contact_obstacles_div {\n    height: 60px;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
